import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, MessageSquare } from 'lucide-react';
import { EMPTY_VALUE } from '../taskTheme';
import type { TaskSource } from '@/types/task';

interface TaskSourceRowProps {
  source: TaskSource | null;
  /** The conversation being read right now, when the panel is open inside one. */
  currentExecutionId?: string | null;
}

/**
 * Where the task came from.
 *
 * A link only when it leads somewhere else: inside the conversation that
 * created the task, it is the room the reader is already standing in.
 */
export const TaskSourceRow = ({ source, currentExecutionId }: TaskSourceRowProps) => {
  const navigate = useNavigate();

  if (!source) {
    return <span className={EMPTY_VALUE}>—</span>;
  }

  if (source.workflow_execution_id === currentExecutionId) {
    return (
      <span className="flex min-w-0 items-center gap-[7px] text-[13.5px] text-[#696969]">
        <MessageSquare className="size-[15px] shrink-0 text-[#9A9A9A]" aria-hidden />
        This chat
      </span>
    );
  }

  return (
    <button
      type="button"
      className="group -mx-[9px] inline-flex min-w-0 max-w-full items-center gap-[7px] rounded-md px-[9px] py-1 text-[13.5px] text-[#181818] hover:bg-[#F6F5F1]"
      onClick={() => navigate(`/ui/chat/${source.workflow_execution_id}`)}
    >
      <MessageSquare className="size-[15px] shrink-0 text-[#9A9A9A]" aria-hidden />
      <span className="truncate">{source.title ?? 'Chat'}</span>
      <ArrowUpRight
        className="size-3.5 shrink-0 text-[#9A9A9A] opacity-0 transition-opacity group-hover:opacity-100"
        aria-hidden
      />
    </button>
  );
};
